import styles from './VerticalHero.scss';

import { ReferencedEntry } from 'contentful';
import React from 'react';

import { Topic } from 'src/api/contentful/contentTypes.cloverdotcom';

import { FloatingTextModulePresentational } from '../../FloatingTextModule/FloatingTextModule';

export interface IVerticalHero {
  entry?: ReferencedEntry<Topic>;
}

export const VerticalHero: React.FC<IVerticalHero> = ({ entry, ...props }) => {
  if (!entry || !entry.fields) return null;

  return (
    <FloatingTextModulePresentational
      topic={entry}
      className={styles.heroModuleWrapper}
      isFullWidthVariation
      titleTagName="h1"
      {...props}
    />
  );
};
